import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { THEME_COLORS, THEMES } from '../components/Constants';
import useSubscriptionStatus from '../hooks/useSubscriptionStatus'; // Import ajouté

export default function BillingPage() {
    const { currentTheme } = useTheme();
    const themeColors = THEME_COLORS[currentTheme] || THEME_COLORS[THEMES.BLUE];
    
    // 🔑 On récupère 'plan' ici pour corriger l'erreur no-undef
    const { plan } = useSubscriptionStatus();

    const plans = [
        { name: 'TRIAL', price: 'Gratuit', duration: '90 jours', accounts: '2', features: ['Budget Expert', 'Multi-utilisateurs'], export: false },
        { name: 'STANDARD', price: '4.99€', duration: 'Mensuel', accounts: '5', features: ['Budget Expert', 'Export CSV'], export: true },
        { name: 'PREMIUM', price: '7.99€', duration: 'Mensuel', accounts: 'Illimité', features: ['Budget Expert', 'Multi-utilisateurs', 'Export CSV'], export: true },
    ];

    const styles = {
        container: { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 20px', minHeight: '100vh' },
        card: { 
            backgroundColor: '#fff', padding: '20px', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', 
            width: '250px', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' 
        },
        button: { padding: '10px', borderRadius: '5px', border: 'none', cursor: 'pointer', fontWeight: 'bold', marginTop: '20px' }
    };

    return (
        <div style={styles.container}>
            <h2 style={{ color: themeColors.secondary, marginBottom: '30px' }}>Choisissez votre Plan</h2>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                {plans.map(p => (
                    <div key={p.name} style={{ ...styles.card, border: plan === p.name ? `3px solid ${themeColors.success}` : '1px solid #ddd' }}>
                        <div>
                            <h3 style={{ color: themeColors.primary }}>{p.name}</h3>
                            <div style={{ fontSize: '1.5em', fontWeight: 'bold', margin: '10px 0' }}>{p.price}</div>
                            <p style={{ fontSize: '0.9em', color: '#666' }}>{p.duration}</p>
                            <hr />
                            <ul style={{ textAlign: 'left', fontSize: '0.85em', listStyle: 'none', padding: '10px' }}>
                                <li>✅ {p.accounts} Comptes</li>
                                {p.features.map(f => <li key={f}>✅ {f}</li>)}
                                <li>{p.export ? '✅' : '❌'} Export de données</li>
                            </ul>
                        </div>
                        <button style={{ 
                            ...styles.button, 
                            backgroundColor: plan === p.name ? '#ccc' : themeColors.success,
                            color: '#fff'
                        }}>
                            {plan === p.name ? 'Plan Actuel' : 'Choisir ce plan'}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}